<ng-template #headerTemplate let-panel>
  <div class="expansion-panel-header-text">
    <capra-icon
      icon="icon-caret-down"
      class="expansion-panel-header-icon"
      [ngClass]="{ 'expansion-panel-header-icon-closed': panelStates[panel] === PanelState.Closed }"
    ></capra-icon
    ><span>{{ panel }}</span>
  </div>
</ng-template>

<mode-format-builder-field-selector
  #fieldSelector
  [fields]="fieldList"
  [selectedFieldToFormat]="selectedFieldToFormat"
  (fieldSelected)="onFieldSelected($event)"
>
</mode-format-builder-field-selector>
<ng-container *ngIf="selectedField">
  <mat-accordion multi="true" class="vegas-marks-accordion">
    <!-- DISPLAY NAME  -->
    <mat-expansion-panel
      [expanded]="true"
      *ngIf="!selectedField.isSystem"
      hideToggle
      (opened)="panelStateChange('Header', PanelState.Open)"
      (closed)="panelStateChange('Header', PanelState.Closed)"
    >
      <mat-expansion-panel-header class="header-form-control">
        <ng-container
          *ngTemplateOutlet="
            headerTemplate;
            context: {
              $implicit: 'Display Label'
            }
          "
        >
        </ng-container>
      </mat-expansion-panel-header>
      <mode-display-label [field]="selectedField" (update)="updateDisplayName($event)"></mode-display-label>
    </mat-expansion-panel>
    <!--
    HEADER // Discrete fields only
  -->
    <mat-expansion-panel
      [expanded]="true"
      *ngIf="selectedField.isDiscrete"
      hideToggle
      (opened)="panelStateChange('Header', PanelState.Open)"
      (closed)="panelStateChange('Header', PanelState.Closed)"
    >
      <mat-expansion-panel-header class="header-form-control">
        <ng-container
          *ngTemplateOutlet="
            headerTemplate;
            context: {
              $implicit: isSelectedFieldOnDiscreteAxis ? 'Axis' : 'Header'
            }
          "
        >
        </ng-container>
      </mat-expansion-panel-header>
      <mode-format-builder-header
        [field]="selectedField"
        [fieldSuggestedBinInfo]="selectedFieldSuggestedBinInfo"
        [headerFormat]="headerFormat"
        [chartType]="chartType"
        [isAxis]="isSelectedFieldOnDiscreteAxis"
        (update)="updateHeader($event)"
      >
      </mode-format-builder-header>
    </mat-expansion-panel>
    <!--
    AXIS // Continuous fields only
  -->
    <mat-expansion-panel
      [expanded]="panelStates.Axis === PanelState.Open"
      *ngIf="selectedField.isContinuous && chartType !== 'vegasPivotTable'"
      hideToggle
      (opened)="panelStateChange('Axis', PanelState.Open)"
      (closed)="panelStateChange('Axis', PanelState.Closed)"
    >
      <mat-expansion-panel-header class="header-form-control">
        <ng-container
          *ngTemplateOutlet="
            headerTemplate;
            context: {
              $implicit: 'Axis'
            }
          "
        >
        </ng-container>
      </mat-expansion-panel-header>
      <ng-container *ngIf="isSelectedFieldBaselineOnly; then baselineWarning; else axisFormatBuilder"></ng-container>
      <ng-template #axisFormatBuilder>
        <mode-format-builder-axis [field]="selectedField" [axisFormat]="axisFormat" (update)="updateAxis($event)">
        </mode-format-builder-axis>
      </ng-template>
      <ng-template #baselineWarning
        ><div class="baseline-warning">
          <p>Axis settings for ranges are controlled by the field on columns or rows.</p>
        </div></ng-template
      >
    </mat-expansion-panel>
    <!--
    PANE // Discrete AND continuous field
  -->
    <mat-expansion-panel
      *ngIf="selectedField.type === 'Field'"
      [expanded]="panelStates.Pane === PanelState.Open"
      hideToggle
      (opened)="panelStateChange('Pane', PanelState.Open)"
      (closed)="panelStateChange('Pane', PanelState.Closed)"
    >
      <mat-expansion-panel-header
        class="header-form-control"
        *ngIf="(selectedField.isDiscrete && chartType !== 'vegasPivotTable') || selectedField.isContinuous"
      >
        <ng-container
          *ngTemplateOutlet="
            headerTemplate;
            context: {
              $implicit: 'Pane'
            }
          "
        >
        </ng-container>
      </mat-expansion-panel-header>
      <mode-format-builder-pane
        [field]="selectedField"
        [format]="paneFormat"
        (update)="updatePane($event)"
        [chartType]="chartType"
      >
      </mode-format-builder-pane>
    </mat-expansion-panel>
    <!--
      LEGEND
    -->
    <mat-expansion-panel
      *ngIf="selectedField?.isLegend"
      [expanded]="true"
      hideToggle
      (opened)="panelStateChange('Legend', PanelState.Open)"
      (closed)="panelStateChange('Legend', PanelState.Closed)"
    >
      <mat-expansion-panel-header class="header-form-control">
        <ng-container
          *ngTemplateOutlet="
            headerTemplate;
            context: {
              $implicit: 'Legend'
            }
          "
        >
        </ng-container>
      </mat-expansion-panel-header>
      <mode-format-builder-legend
        [legend]="legendFormat"
        [field]="selectedField"
        (update)="updateLegend($event)"
      ></mode-format-builder-legend>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>
